import {
    NAVIGATE_NEXT,
    NAVIGATE_PREVIOUS,
    navigateToDigitalSavingsQuote,
    navigateToPersonalDetails,
    navigateToBeneficiaries,
    navigateToUploadDocuments,
    navigateToPayment,
} from '../../../actions/digitalSavings/routing';
import { getActivePageIndex } from '../../../selectors/digitalSavings/routing';
import { PAGE_INDICES } from '../../../actions/digitalSavings/types';
import { apiTransitionDigitalSavingsPersonalDetailsForm } from '../../../actions/digitalSavings/personalDetails';
import { apiTransitionDocumentsForm } from '../../../actions/digitalSavings/Documents';
import { apiTransitionBeneficiariesForm } from '../../../actions/digitalSavings/beneficiaries';

export const routingRules = (store, next, action) => {
    if (action.type !== NAVIGATE_NEXT && action.type !== NAVIGATE_PREVIOUS) return next(action);
    const result = next(action);
    const state = store.getState();
    const activePageIndex = getActivePageIndex(state);
    if (action.type === NAVIGATE_NEXT) {
        onNavigateNext(store, state, activePageIndex);
        return result;
    }
    onNavigatePrevious(store, state, activePageIndex);
    return result;
};

const onNavigateNext = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.QOUTE:
            store.dispatch(navigateToPersonalDetails());
            break;
        case PAGE_INDICES.PERSONAL_DETAILS:
            store.dispatch(navigateToBeneficiaries());
            break;

        case PAGE_INDICES.BENEFICIARIES:
            store.dispatch(navigateToUploadDocuments());
            break;
        case PAGE_INDICES.UPLOAD_DOCUMENTS:
            store.dispatch(navigateToPayment());
            break;
        default:
            store.dispatch(navigateToDigitalSavingsQuote());
            break;
    }
};

const onNavigatePrevious = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.PERSONAL_DETAILS:
            store.dispatch(navigateToDigitalSavingsQuote());
            break;

        case PAGE_INDICES.BENEFICIARIES:
            store.dispatch(apiTransitionDigitalSavingsPersonalDetailsForm.initial())
            store.dispatch(navigateToPersonalDetails());
            break;

        case PAGE_INDICES.UPLOAD_DOCUMENTS:
            store.dispatch(apiTransitionBeneficiariesForm.initial())
            store.dispatch(navigateToBeneficiaries());
            break;
        case PAGE_INDICES.PAYMENT:
            store.dispatch(apiTransitionDocumentsForm.initial())
            store.dispatch(navigateToUploadDocuments());
            break;
        default:
            store.dispatch(navigateToDigitalSavingsQuote());
            break;
    }
};
